<template>
    <span class="kb-dot" :class="{'kb-dot--lg': size === 'lg'}" :title="title" />
</template>

<script>
export default {
    name: 'kb-dot',
    props: {
        size: {type: String, default: 'sm'},
        title: {type: String, default: ''},
    },
};
</script>

<style lang="scss" scoped>
.kb-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #f5a623;
    margin-right: 6px;
    vertical-align: middle;
    cursor: help;

    &--lg {
        width: 10px;
        height: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/knowledge-base/kb-dot.vue